import {
    type ApiEndpoint,
    type DownloadUrlResponse,
    isDownloadUrlResponse,
} from "@/shared/api-endpoint";
import {
    kBalanceRange,
    kComplexity30Range,
    kPitchPaletteLength,
    kVariationRange,
} from "@/shared/magic-fit-3.0.api";
import { isObject } from "@/shared/utils/typeGuards";

export const kMagicFit35Route = "/magic-fit-3.5";

// The 3.5 app maps balance onto its 8-step PingPong sampler so the guidance it
// applies matches what 3.0's 32-step Euler applies at the same value, so 3.0's
// defaults, balance included, carry over unchanged.
export { kBalanceRange, kComplexity30Range, kPitchPaletteLength, kVariationRange };

export interface MagicFit35RequestBody {
    drivingAudioKey: string;
    timbreAudioKey: string;
    bpm: number;
    pitchPalette?: number[];
    variation?: number;
    balance?: number;
    complexity?: number;
}

export const isMagicFit35RequestBody = (value: unknown): value is MagicFit35RequestBody =>
    isObject(value) &&
    typeof value.drivingAudioKey === "string" &&
    typeof value.timbreAudioKey === "string" &&
    typeof value.bpm === "number";

export const kMagicFit35Endpoint: ApiEndpoint<MagicFit35RequestBody, DownloadUrlResponse> = {
    route: kMagicFit35Route,
    label: "Magic Fit 3.5 fast",
    source: "Modal",
    isEvaluationOnly: true,
    category: "SpliceGen v3.5 fast",
    description:
        "Magic Fit using a faster version of the SpliceGen 3.0 model with complexity control over the timbre transfer.",
    isRequestBody: isMagicFit35RequestBody,
    isSuccessResponse: isDownloadUrlResponse,
};
